'use client'

import cookies from 'js-cookie'
import { COOKIE_SALARY_FILTER_PARAMS } from '@/modules/salary/filters/utils'
import { useEffect } from 'react'
import { omitBy, isEmpty } from 'lodash'
import { SalaryFiltersParams } from '@/modules/salary/types'

/**
 * This saves the filters to cookies if the user visits the URL
 * directly by URL.
 */
export function SalaryPageFiltersSaver({
  salaryFilters,
}: {
  salaryFilters: Partial<SalaryFiltersParams>
}) {
  useEffect(() => {
    cookies.set(
      COOKIE_SALARY_FILTER_PARAMS,
      JSON.stringify(omitBy(salaryFilters, isEmpty)),
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}
